(function() {
  "use strict";
  try {
    if (typeof document != "undefined") {
      var elementStyle = document.createElement("style");
      elementStyle.appendChild(document.createTextNode(".leaflet-popup.leaflet-freietonne h2,.leaflet-popup.leaflet-freietonne p {\n    margin: 5px 0;\n}"));
      document.head.appendChild(elementStyle);
    }
  } catch (e) {
    console.error("vite-plugin-css-injected-by-js", e);
  }
})();
import * as L from "leaflet";
function encodeQueryString(obj) {
  return Object.keys(obj).map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`).join("&");
}
function getFreieTonneUrl(bounds, zoom) {
  return `https://www.freietonne.de/seekarte/getOpenLayerPois.php?${encodeQueryString({
    ldez1: bounds.getWest(),
    ldez2: bounds.getEast(),
    bdez1: bounds.getNorth(),
    bdez2: bounds.getSouth(),
    zoom
  })}`;
}
function decodeFreieTonneFeatures(content) {
  return content.trim().split(/\r\n|\r|\n/).slice(1).map((line) => {
    const feature = line.split(/\t/);
    const latLng = [Number(feature[0]), Number(feature[1])];
    const iconUrl = `https://www.freietonne.de/seekarte/${feature[6]}`;
    const iconSize = feature[4].split(",").map((n) => Number(n));
    const iconAnchor = feature[5].split(",").map((n, i) => iconSize[i] + Number(n));
    const popupAnchor = [-iconAnchor[0] + Math.round(iconSize[0] / 2), -iconAnchor[1]];
    const content2 = cleanUpContent(feature[2], feature[3]);
    return { latLng, iconUrl, iconSize, iconAnchor, popupAnchor, content: content2 };
  });
}
async function fetchFreieTonneFeatures(bounds, zoom) {
  const content = await fetch(getFreieTonneUrl(bounds, zoom)).then((res) => res.text());
  return decodeFreieTonneFeatures(content);
}
function cleanUpContent(header, content) {
  if (content === "")
    return "";
  const result = document.createElement("div");
  result.innerHTML = content;
  const headerEl = document.createElement("h2");
  headerEl.innerHTML = header;
  if (headerEl.innerText.trim() !== "")
    result.prepend(headerEl);
  for (const el of Array.from(result.querySelectorAll("a,span"))) {
    while (el.firstChild)
      el.parentNode.insertBefore(el.firstChild, el);
    el.parentNode.removeChild(el);
  }
  for (const el of Array.from(result.querySelectorAll("[style],[onclick]"))) {
    el.removeAttribute("style");
    el.removeAttribute("onclick");
  }
  return result.innerHTML;
}
class FreieTonne extends L.FeatureGroup {
  constructor(options = {}) {
    super([], {
      attribution: '© <a href="https://www.freietonne.de/" target="_blank">FreieTonne</a> / <a href="https://www.openstreetmap.org/copyright" target="_blank">OSM Contributors</a>',
      ...options
    });
  }
  getEvents() {
    return {
      moveend: this.redraw
    };
  }
  onAdd() {
    this.redraw();
    return this;
  }
  async redraw() {
    const zoom = this._map.getZoom();
    if (zoom <= 8) {
      this.clearLayers();
      return;
    }
    const features = await fetchFreieTonneFeatures(this._map.getBounds(), zoom);
    this.clearLayers();
    for (const feature of features) {
      const marker = L.marker(feature.latLng, {
        icon: L.icon({
          iconUrl: feature.iconUrl,
          iconSize: feature.iconSize,
          iconAnchor: feature.iconAnchor,
          popupAnchor: feature.popupAnchor
        })
      });
      if (feature.content)
        marker.bindPopup(feature.content, { className: "leaflet-freietonne" });
      this.addLayer(marker);
    }
  }
}
export {
  cleanUpContent,
  decodeFreieTonneFeatures,
  FreieTonne as default,
  fetchFreieTonneFeatures,
  getFreieTonneUrl
};
//# sourceMappingURL=L.FreieTonne.js.map
